/**
 * @file Device detector helper.
 */

import getConfig from './config';

const isMobile = () => {
  const config = getConfig();
  const { userAgent } = config.client;

  if (!userAgent) {
    return false;
  }

  return /iP(?:ad|hone|od)|Android|Mobile/.test(userAgent);
};

/**
 * Ref https://stackoverflow.com/questions/9038625/detect-if-device-is-ios.
 */
const isIOS = () => {
  const config = getConfig();
  const { userAgent } = config.client;

  if (!userAgent) {
    return false;
  }

  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

/**
 * Attemps to determine if we're in a webview (iOS or Android).
 * Pretty much completely stolen from https://github.com/atomantic/is-ua-webview.
 *
 * @param {string} userAgent The user agent string.
 * @returns {boolean}
 */
const isWebview = userAgent => {
  const rules = [
    // if it says it's a webview, let's go with that
    'WebView',
    // iOS webview will be the same as safari but missing "Safari"
    '(iPhone|iPod|iPad)(?!.*Safari)',
    // Android Lollipop and Above: webview will be the same as native but it will contain "wv"
    // Android KitKat to Lollipop webview will put Version/X.X Chrome/{version}.0.0.0
    'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
    // old chrome android webview agent
    'Linux; U; Android',
  ];

  const re = new RegExp(`(${rules.join('|')})`, 'ig');

  return !!userAgent.match(re);
};

export { isMobile, isIOS, isWebview };
